import Icon from '../components/Icon.vue'

Icon.register({"glass":{"width":1792,"height":1792,"paths":[{"d":"M1699 186q0 35-43 78l-632 632v768h320q26 0 45 19t19 45-19 45-45 19h-896q-26 0-45-19t-19-45 19-45 45-19h320v-768l-632-632q-43-43-43-78 0-23 18-36.5t38-17.5 43-4h1408q23 0 43 4t38 17.5 18 36.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/glass.js
// module id = 342
// module chunks = 0